import { dayjs } from './dayjs';

export const getLocalTimezone = () => dayjs.tz.guess();
export const formatLocalTime = (
  value: string | Date,
  locale: string,
  pattern = 'LT',
  zone = getLocalTimezone(),
): string => dayjs(value).tz(zone).locale(locale.toLowerCase()).format(pattern);
